import * as types from "./types";

export const checkFilter = isValid => {
  return {
    type: types.CHECK_FILTER,
    isValid
  };
};

export const getNextStep = payload => {
  return {
    type: types.FILTER_GET_NEXT_STEP,
    payload
  };
};
